module.exports = __webpack_public_path__ + "media/images/setting/icon5-c8eca12b7409e0ae57f90c417d354adf.svg";